import { useSelector } from 'react-redux';
import {
  FALLBACK_COUNTRIES,
  findCountryByCode,
  getDefaultCountry,
  resolveCountryFromPath,
} from '../utils/country';

/** The country registry, falling back to the bundled markets before the API responds. */
export const useCountryRegistry = () => useSelector((state) => (
  state?.countries?.data?.length ? state.countries.data : FALLBACK_COUNTRIES
));

/**
 * The market currently in view.
 *
 * The URL wins over Redux so links built during a country switch point at the market the user
 * is actually looking at, and country-agnostic /all/... routes fall back to the active market.
 */
export const useActiveCountry = () => {
  const countries = useCountryRegistry();
  const pathname = useSelector((state) => state?.router?.location?.pathname || '');
  const activeCode = useSelector((state) => state?.locationMeta?.data?.country_shortCode);

  const { country } = resolveCountryFromPath(pathname, countries);
  return country || findCountryByCode(countries, activeCode) || getDefaultCountry(countries);
};

/** URL segment of the market currently in view, e.g. "Sri-Lanka" or "Singapore". */
export const useCountryPath = () => useActiveCountry()?.urlPath;

export default useCountryPath;
